/**
 * OIDC Debug Helper
 * 
 * Temporary debugging component to investigate OIDC authentication issues
 * This should be added to the LoginCallback component to help diagnose the problem
 */

export const debugOIDCCallback = () => {
  // Parse OIDC parameters from URL
  const urlParams = new URLSearchParams(window.location.search);
  const oidcParams = {
    code: urlParams.get('code'),
    state: urlParams.get('state'),
    scope: urlParams.get('scope'),
    session_state: urlParams.get('session_state'),
    iss: urlParams.get('iss'),
    error: urlParams.get('error'),
    error_description: urlParams.get('error_description')
  };
  
  // Check for OIDC-related errors
  const oidcError = sessionStorage.getItem('oidc.error') || localStorage.getItem('oidc.error');
  if (oidcError) {
    console.error('OIDC Error found:', oidcError);
  }
  
  return oidcParams;
};

/**
 * Enhanced useAppIdentity hook with debugging
 * Returns identity state information for diagnostic purposes
 */
export const debugAppIdentity = (identity: any) => {
  // Get identity-related storage keys
  const identityKeys = Object.keys(localStorage).filter(key => 
    key.startsWith('oidc.') || key.includes('identity')
  );
  
  return {
    identityState: {
      isAuthenticated: identity.isAuthenticated,
      isLoading: identity.isLoading,
      isError: identity.isError,
      error: identity.error,
      user: identity.user
    },
    storageKeys: identityKeys
  };
};
